import { IntlShape } from 'react-intl'
import { create, enforce, omitWhen, test } from 'vest'
import { messages } from './messages'

const NO_ONLY_BLANK_SPACES = /^(?!\s*$).+/

export function validationSuite(name: string, intl: IntlShape) {
  return create((tag: string) => {
    const { $t } = intl

    omitWhen(!tag.length, () => {
      test(name, $t(messages.validation.empty), () => {
        enforce(tag).matches(NO_ONLY_BLANK_SPACES)
      })
    })
  })
}
